import api, { ApiResponse } from './api';

export interface TaskRecipient {
  id: number;
  taskId: number;
  email: string;
  name?: string;
}

export interface ScheduledTask {
  id: number;
  title: string;
  description?: string;
  reportType: string;
  frequency: string;
  runTime?: string;
  format?: string;
  status: 'ACTIVE' | 'PAUSED';
  nextRun?: string;
  lastRun?: string;
  createdBy?: number;
  createdByName?: string;
  createdDate: string;
  updatedDate?: string;
  recipients: TaskRecipient[];
}

export interface ScheduledTaskCreateDto {
  title: string;
  description?: string;
  reportType: string;
  frequency: string;
  runTime?: string;
  format?: string;
  createdBy?: number;
  recipientEmails?: string[];
}

// Rapor turleri
export const REPORT_TYPES = [
  { value: 'ATTENDANCE', label: 'Devamsizlik Raporu' },
  { value: 'OVERTIME', label: 'Fazla Mesai Raporu' },
  { value: 'LATE', label: 'Gec Kalma Raporu' },
  { value: 'DEPARTMENT', label: 'Departman Ozeti' },
];

// Siklik secenekleri
export const FREQUENCY_OPTIONS = [
  { value: 'DAILY', label: 'Her Gun', description: 'Her gun belirtilen saatte' },
  { value: 'WEEKLY', label: 'Haftalik', description: 'Her Pazartesi' },
  { value: 'MONTHLY', label: 'Aylik', description: 'Her ayin 1\'i' },
];

// Format secenekleri
export const FORMAT_OPTIONS = [
  { value: 'PDF', label: 'PDF' },
  { value: 'EXCEL', label: 'Excel' },
  { value: 'CSV', label: 'CSV' },
];

const scheduledTasksService = {
  // Tum gorevleri getir
  getAll: async (): Promise<ApiResponse<ScheduledTask[]>> => {
    return api.get('/scheduled-tasks');
  },

  // Gorev detayi
  getById: async (id: number): Promise<ApiResponse<ScheduledTask>> => {
    return api.get(`/scheduled-tasks/${id}`);
  },

  // Yeni gorev olustur
  create: async (data: ScheduledTaskCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/scheduled-tasks', data);
  },

  // Gorev guncelle
  update: async (id: number, data: ScheduledTaskCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/scheduled-tasks/${id}`, data);
  },

  // Gorev durumunu degistir
  toggleStatus: async (id: number): Promise<ApiResponse<{ id: number; status: string }>> => {
    return api.patch(`/scheduled-tasks/${id}/toggle-status`, {});
  },

  // Gorev sil
  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/scheduled-tasks/${id}`);
  },

  // Gorevi simdi calistir
  runNow: async (id: number): Promise<ApiResponse<{ id: number; executed: string }>> => {
    return api.post(`/scheduled-tasks/${id}/run-now`, {});
  },
};

export default scheduledTasksService;
